import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'project-versions.table.empty.header',
		defaultMessage: 'No matching versions',
		description:
			'This message is shown when there are no versions that match filters and/or search',
	},
	noMatchingStatusDescription: {
		id: 'project-versions.table.empty.no-matching-status-description',
		defaultMessage:
			"There aren't any versions in this project with that status. Check your filters and try again.",
		description: 'This message is shown when there are no versions with matching status to display',
	},
	defaultDescription: {
		id: 'project-versions.table.empty.default-description',
		defaultMessage:
			"There aren't any versions in this project that match your search. Check your search terms and filters and try again.",
		description:
			'This message is shown when there are no versions that match search term and filters',
	},
	headerGalaxia: {
		id: 'project-versions.table.empty.header-galaxia',
		defaultMessage:
			"There aren't any versions in this space with that status. Check your filters and try again.",
		description:
			'This message is shown when there are no versions that match filters and/or search',
	},
	defaultDescriptionGalaxia: {
		id: 'project-versions.table.empty.default-description-galaxia',
		defaultMessage:
			"There aren't any versions in this space that match your search. Check your search terms and filters and try again.",
		description:
			'This message is shown when there are no versions that match search term and filters',
	},
});
